
const LearningStats = () => {
  const stats = [
    {
      label: 'Days Studied',
      value: '45',
      icon: 'ri-calendar-check-line',
      color: 'blue',
      change: '+5 this week'
    },
    {
      label: 'Lessons Completed',
      value: '23',
      icon: 'ri-checkbox-circle-line',
      color: 'green',
      change: '+3 this week'
    },
    {
      label: 'Words Learned',
      value: '342',
      icon: 'ri-chat-3-line',
      color: 'purple',
      change: '+28 this week'
    },
    {
      label: 'Speaking Minutes',
      value: '127',
      icon: 'ri-mic-line',
      color: 'orange',
      change: '+15 this week'
    },
    {
      label: 'Current Streak',
      value: '7',
      icon: 'ri-fire-line',
      color: 'red',
      change: 'Keep it up!'
    },
    {
      label: 'Accuracy Rate',
      value: '89%',
      icon: 'ri-target-line',
      color: 'indigo',
      change: '+2% this week'
    }
  ];

  const weeklyData = [
    { day: 'Mon', minutes: 25 },
    { day: 'Tue', minutes: 40 },
    { day: 'Wed', minutes: 30 },
    { day: 'Thu', minutes: 45 },
    { day: 'Fri', minutes: 35 },
    { day: 'Sat', minutes: 20 },
    { day: 'Sun', minutes: 50 }
  ];

  const maxMinutes = Math.max(...weeklyData.map(d => d.minutes));

  const getColorClasses = (color: string) => {
    const colorMap = {
      blue: 'bg-blue-500',
      green: 'bg-green-500',
      purple: 'bg-purple-500',
      orange: 'bg-orange-500',
      red: 'bg-red-500',
      indigo: 'bg-indigo-500',
    };
    return colorMap[color as keyof typeof colorMap];
  };

  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              Your Learning Statistics
            </h2>
            <p className="text-xl text-gray-600">
              See how much you've accomplished and track your consistency
            </p>
          </div>

          {/* Stats Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
            {stats.map((stat, index) => (
              <div key={index} className="bg-gray-50 rounded-xl p-6 hover:shadow-md transition-shadow">
                <div className="flex items-center justify-between mb-4">
                  <div className={`w-12 h-12 ${getColorClasses(stat.color)} rounded-lg flex items-center justify-center`}>
                    <i className={`${stat.icon} text-white text-xl`}></i>
                  </div>
                  <span className="text-sm text-green-600 font-medium">{stat.change}</span>
                </div>
                <div className="text-3xl font-bold text-gray-900 mb-1">{stat.value}</div>
                <div className="text-gray-600">{stat.label}</div>
              </div>
            ))}
          </div>

          {/* Weekly Activity Chart */}
          <div className="bg-gray-50 rounded-2xl p-8">
            <h3 className="text-2xl font-bold text-gray-900 mb-6">This Week's Activity</h3>
            <div className="flex items-end justify-between space-x-4 h-64">
              {weeklyData.map((data, index) => (
                <div key={index} className="flex flex-col items-center flex-1">
                  <div className="w-full bg-gray-200 rounded-t-lg relative" style={{ height: '200px' }}>
                    <div 
                      className="bg-blue-500 rounded-t-lg absolute bottom-0 w-full transition-all duration-500"
                      style={{ height: `${(data.minutes / maxMinutes) * 100}%` }}
                    ></div>
                  </div>
                  <div className="mt-2 text-center">
                    <div className="text-sm font-medium text-gray-900">{data.minutes}m</div>
                    <div className="text-xs text-gray-500">{data.day}</div>
                  </div>
                </div>
              ))}
            </div>
            <div className="text-center mt-6">
              <p className="text-gray-600">
                Total this week: <span className="font-semibold text-gray-900">245 minutes</span> • 
                Average: <span className="font-semibold text-gray-900">35 minutes/day</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LearningStats;
